import React, { useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import ReactGA from 'react-ga4';
import './i18n';

import HomePage from './pages/homepage/homepage.component';
import SolutionPage from './pages/solutionpage/solutionpage.component';
import ResourcesPage from './pages/resourcespage/resources.component';
import AboutPage from './pages/aboutpage/aboutpage.component';
import TechnoPage from './pages/technopage/techno.component';
import PrivacyPage from './pages/technopage/privacy/privacy.component';

import SubscriberPage from './pages/subscriberpage/subscriber.component';
import SSIPage from './pages/ssi-page/ssi-page.component';
import ErrorPage from './pages/errorpage/error.component';
import RequestSalesPage from './pages/requestsalespage/requestsalespage.component';
import MobileAppPrivacy from './pages/technopage/privacy/mobile.application.end.user.license';
import AppPrivacy from './pages/technopage/privacy/app.privacy-policy';
import TermsAndConditions from './pages/technopage/privacy/terms.and.conditions';
import AppDownload from './pages/technopage/privacy/appDownload';
import WoccuAppDownload from './pages/technopage/privacy/woccuAppDownload';
import AppDownloadMasterCard from './pages/technopage/privacy/appDownload-m';
import AppDownloadWoccu from './pages/technopage/privacy/appDownload-w';
import AppDownloadProd from './pages/technopage/privacy/appDownloadProd';

const App = () => {
 // const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const trackingId = process.env.REACT_APP_GA_TRACKING_NO;
    console.log('Got tracking id', trackingId);
    const consentCategories = window?.CookieScript?.consentCategories || [];

    console.log('consentCategories:', consentCategories);
    const tryInitGA = () => {
      if (
        trackingId 
      ) {
        console.log('[CookieScript] Analytics consent granted');
        ReactGA.initialize(trackingId);
        ReactGA.send({
          hitType: 'pageview',
          page: window.location.pathname + window.location.search
        });
  
        const unlisten = history.listen((location) => {
          ReactGA.send({
            hitType: 'pageview',
            page: location.pathname + location.search
          });
        });
  
        return () => unlisten();
      } else {
        console.log('[CookieScript] Analytics consent NOT granted yet');
      }
    };
  
    // Run immediately on load
    tryInitGA();
  
    // Listen for CookieScript updates (user clicks Accept All / Save Preferences)
    const handler = () => tryInitGA();
    window.addEventListener('CookieScriptConsentUpdated', handler);
  
    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('CookieScriptConsentUpdated', handler);
    };
  }, [history]);
  
  

  return (
    <Switch>
      <Route exact path='/' component={HomePage} />
      <Route path='/solution' component={SolutionPage} />
      <Route path='/resources' component={ResourcesPage} />
      <Route path='/about' component={AboutPage} />
      <Route path='/platform' component={TechnoPage} />
      <Route path='/subscriber' component={SubscriberPage} />
      <Route path='/ssi' component={SSIPage} />
      <Route path='/error' component={ErrorPage} />
      <Route path='/request-sales' component={RequestSalesPage} />
      <Route path='/privacy-policy' component={PrivacyPage} />
      <Route path='/mobile-application-end-user-licence' component={MobileAppPrivacy} />
      <Route path='/app-privacy-policy' component={AppPrivacy} />
      <Route path='/terms-and-conditions' component={TermsAndConditions} />
      <Route path='/demo' component={AppDownload} />
      <Route path='/demo-m' component={AppDownloadMasterCard} />
      <Route path='/demo-w' component={AppDownloadWoccu} />
      <Route path='/woccu-demo' component={WoccuAppDownload} />
      <Route path='/apps' component={AppDownloadProd} />
    </Switch>
  );
};

export default App;
